
import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  ref,
  watch,
  getCurrentInstance,
} from "vue";
import { Loading, Dialog, Toast } from "vant";
import { getUserInfo, parseImgUrl } from "@/utils";
import { queryCustomerservice } from "@/apis/envmonitor";
const userInfo: any = getUserInfo();

export default defineComponent({
  props: {
    isShowContact: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    VanLoading: Loading,
    [Dialog.Component.name]: Dialog.Component,
  },
  setup(props, contx) {
    const contantDetail: any = {};
    const proxyGlobal: any = getCurrentInstance();
    const proxyData = reactive({
      parseImgUrl: parseImgUrl,
      contantDetail: contantDetail,
      userInfo: userInfo,
      imgUrl: proxyGlobal.proxy.$imgUrl,
      isShowContact: props.isShowContact,
      closeDailog() {
        contx.emit("closeDailog");
      },
      // 查询联系方式
      queryCustomerservice() {
        let params: any = {
          criteria: { projectId: proxyData.userInfo.projectId },
        };
        queryCustomerservice(params).then((res) => {
          let resData: any = res;
          let content: any = resData?.content ?? [];
          proxyData.contantDetail = content[0];
        });
      },
    });
    watch(
      props,
      (newProps: any) => {
        proxyData.isShowContact = newProps.isShowContact;
      },
      {
        deep: false,
        immediate: true,
      }
    );
    onMounted(() => {
      proxyData.queryCustomerservice();
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
